import { toast } from "react-toastify";

export const SBNotify = ({ type = 'success', Msg }) => {
    toast(Msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type,
    });
};